import { render, staticRenderFns } from "./ExpandedRow.vue?vue&type=template&id=60231d9a&scoped=true&"
import script from "./ExpandedRow.vue?vue&type=script&lang=ts&"
export * from "./ExpandedRow.vue?vue&type=script&lang=ts&"
import style0 from "./ExpandedRow.vue?vue&type=style&index=0&id=60231d9a&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60231d9a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
